<template>
    <div
        v-if="modal"
        id="history_node_modal"
        class="modal"
        @click.self="changeModal"
        ref="modalContent"
    >
        <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x"
            crossorigin="anonymous"
        />
        <div class="modal-content">
            <div class="modal-header">
                <div class="center_section">
                    <h1>{{ $t("notes.title") }}</h1>
                    <p><b>{{ info.offerName }}</b><br>{{ info.clientName }}</p>
                </div>
                <svg
                    @click="changeModal"
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                >
                    <path
                        d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75"
                        stroke="#5C5C5C"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div
                :class="klientNazovLength ? 'modal-line active' : 'modal-line'"
            ></div>
            <div class="modal-body">
                <div class="history_list">
                    <h6>{{ $t("notes.text_0") }}</h6>
                    <div v-if="notes.length > 0" class="list_container">
                        <div v-for="note in notes" :key="note.id">
                            <div class="list_box" :class="{ form_accepted: note.form_status == 1, form_decline: note.form_status == 2}">
                                <div class="left_side">
                                    <svg v-if="note.form_status == 1" class="clock" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <circle cx="8" cy="8" r="8" fill="#CBF3B8"/>
                                        <path d="M4.9231 8.79123L6.68134 10.5495L11.0769 6.15387" stroke="#212541" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <svg v-else-if="note.form_status == 2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <circle cx="8" cy="8" r="8" fill="#ffc6c4"/>
                                        <path d="M5 11L11 5M5 5L11 11" stroke="#212541" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <svg v-else class="clock" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 14.3996C9.69748 14.3996 11.3253 13.7253 12.5256 12.5251C13.7258 11.3249 14.4001 9.69699 14.4001 7.99961C14.4001 6.30222 13.7258 4.67436 12.5256 3.47413C11.3253 2.27389 9.69748 1.59961 8.0001 1.59961C6.30271 1.59961 4.67485 2.27389 3.47461 3.47413C2.27438 4.67436 1.6001 6.30222 1.6001 7.99961C1.6001 9.69699 2.27438 11.3249 3.47461 12.5251C4.67485 13.7253 6.30271 14.3996 8.0001 14.3996ZM8.8001 4.79961C8.8001 4.58744 8.71581 4.38395 8.56578 4.23392C8.41575 4.08389 8.21227 3.99961 8.0001 3.99961C7.78792 3.99961 7.58444 4.08389 7.43441 4.23392C7.28438 4.38395 7.2001 4.58744 7.2001 4.79961V7.99961C7.20014 8.21177 7.28446 8.41522 7.4345 8.56521L9.6969 10.8284C9.77123 10.9027 9.85947 10.9617 9.95658 11.0019C10.0537 11.0422 10.1578 11.0629 10.2629 11.0629C10.368 11.0629 10.4721 11.0422 10.5692 11.0019C10.6663 10.9617 10.7546 10.9027 10.8289 10.8284C10.9032 10.7541 10.9622 10.6658 11.0024 10.5687C11.0426 10.4716 11.0633 10.3675 11.0633 10.2624C11.0633 10.1573 11.0426 10.0532 11.0024 9.95609C10.9622 9.85898 10.9032 9.77074 10.8289 9.69641L8.8001 7.66841V4.79961Z" fill="#9598A7"/>
                                    </svg>
                                    <span class="line_down"></span>
                                </div>
                                <svg class="corner" xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                                    <path :fill="note.form_status == 1 ? '#CBF3B8' : (note.form_status == 2 ? '#ffc6c4' : 'white')" d="M1.00658 7.97996C0.494869 7.57958 0.49487 6.80518 1.00658 6.40481L8.57617 0.482143C8.93816 0.198908 9.44661 0.198908 9.80861 0.482143L17.3782 6.40481C17.8899 6.80518 17.8899 7.57958 17.3782 7.97996L9.80861 13.9026C9.44661 14.1859 8.93816 14.1859 8.57617 13.9026L1.00658 7.97996Z" />
                                </svg>
                                <span>{{ note.cas }}</span>
                                <p>{{ note.text }}</p>
                                <div class="actions">
                                    <svg
                                        v-if="note.form_status == null"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        data-click="no"
                                        @click="edit(note)"
                                    >
                                        <path
                                            d="M5.5 1H4.5C2 1 1 2 1 4.5V7.5C1 10 2 11 4.5 11H7.5C10 11 11 10 11 7.5V6.5"
                                            stroke-linecap="round"
                                            stroke="#2ed8b6"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M8.02 1.50999L4.08 5.44999C3.93 5.59999 3.78 5.89499 3.75 6.10999L3.535 7.61499C3.455 8.15999 3.84 8.53999 4.385 8.46499L5.89 8.24999C6.1 8.21999 6.395 8.06999 6.55 7.91999L10.49 3.97999C11.17 3.29999 11.49 2.50999 10.49 1.50999C9.49 0.509989 8.7 0.829989 8.02 1.50999Z"
                                            stroke-miterlimit="10"
                                            stroke="#2ed8b6"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M7.45499 2.07498C7.78999 3.26998 8.72499 4.20498 9.92499 4.54498"
                                            stroke-miterlimit="10"
                                            stroke="#2ed8b6"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        data-click="no"
                                        @click="remove(note.id)"
                                    >
                                        <path
                                            d="M10.5 2.99001C8.835 2.82501 7.16 2.74001 5.49 2.74001C4.5 2.74001 3.51 2.79001 2.52 2.89001L1.5 2.99001"
                                            stroke="#F93C34"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M4.25 2.485L4.36 1.83C4.44 1.355 4.5 1 5.345 1H6.655C7.5 1 7.565 1.375 7.64 1.835L7.75 2.485"
                                            stroke="#F93C34"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M9.42507 4.56999L9.10007 9.60499C9.04507 10.39 9.00007 11 7.60507 11H4.39507C3.00007 11 2.95507 10.39 2.90007 9.60499L2.57507 4.56999"
                                            stroke="#F93C34"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M5.16498 8.25H6.82998"
                                            stroke="#F93C34"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M4.75 6.25H7.25"
                                            stroke="#F93C34"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-else>{{ $t('notes.text_7') }}</p>
                </div>
                <div class="main">
                    <h5 v-show="note.id">{{ $t("notes.text_1") }}</h5>
                    <h5 v-show="!note.id">{{ $t("notes.text_2") }}</h5>
                    <div id="floatContainer" class="float-container dateInput">
                        <label class="floatField_dateInput" for="floatField">{{ $t("notes.text_3") }}</label>
                        <date-picker
                            v-model="note.cas"
                            type="datetime"
                            format="DD.MM.YYYY HH:mm"
                            placeholder="dd.mm.rrrr"
                            valueType="format"
                        >
                        </date-picker>
                    </div>
                    <div class="form-floating mb-3">
                        <textarea v-model="note.text" class="form-control" placeholder="Poznámka" id="floatingTextarea3" style="height: 148px"></textarea>
                        <label for="floatingTextarea3">{{$t("notes.text_4")}}</label>
                    </div>
                </div>
                <div class="action_btns_bottom">
                    <div class="back_btn" @click="reset">
                        <span>{{$t("klient.text_50")}}</span>
                    </div>
                    <div class="ulozit" @click="save">
                        <span v-show="!saved" id="saveKlient">{{
                            isEdit
                                ? $t("klient.text_40")
                                : $t("klient.text_41")
                        }}</span>
                        <div v-show="saved" class="lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
    props: ["statusHistoryNodes","uuid", "notes","info"],
    components: {
        DatePicker,
    },
    data() {
        return {
            modal: false,
            note: {
                cas: null,
                text: null,
                uuid: null,
            },
            saved: false,
            isEdit: false
        };
    },
    
    methods: {
        changeModal() {
            this.modal = !this.modal;
            if (this.modal) {
                document.documentElement.style.overflow = "hidden";
                setTimeout(() => {
                    this.$refs.klientNazov.focus();
                }, 500);
            } else {
                document.documentElement.style.overflow = "auto";
                this.$emit("closeModal", false);
                this.reset();
                this.isEdit = false;
            }
        },
        edit(note){
            this.note.text = note.text
            this.note.cas = note.cas
            this.note.id = note.id
            this.isEdit = true
        },
        remove(id) {
            axios
                .post(`/api/notes/delete`, { id: id, uuid: this.uuid })
                .then((response) => {
                    this.$toast.success(this.$t("notes.text_alert_1"), {
                        timeout: 1500,
                    });
                    this.notes = response.data;
                });
        },
        save() {
            if (!this.note.text || this.note.text.trim() === "" || !this.note.cas || this.note.cas.trim() === "") {
                return;
            }
            this.saved = true
            this.note.uuid = this.uuid;
            axios.post(`/api/notes/create`, this.note)
                .then((response) => {
                    const textKey = this.note.id ? "notes.text_alert_3" : "notes.text_alert_2";
                    const text = this.$t(textKey);
                    this.$toast.success(text, { timeout: 1500 });
                    this.reset();
                    this.notes = response.data;
                    this.saved = false
                });
        },
        reset() {
            this.note = {
                cas: null,
                text: null,
                uuid: null,
            };
            this.isEdit = false
        },
    },
    watch: {
        statusHistoryNodes: function () {
            if (this.statusHistoryNodes) this.changeModal();
        },
    },
};
</script>
<style lang="scss"> 

#klient_nazov::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
}
.Vue-Toastification__container.top-right {
    z-index: 100000 !important;
}
.mx-datepicker-popup {
    z-index: 100000 !important;
}
.mx-datepicker-content{
    margin-left:125px!important;
}
.mx-datepicker-sidebar{
    width:125px!important;
}

.float-container {
    border: 1px solid #dde3e8;
    border-radius: 0;
    margin: 20px 0px;
}
.dateInput {
    display: grid;
    input.mx-input{
        border: none!important;
        border: none;
        box-shadow: none!important;
        color: #000;
        font-size: 16px;
        line-height: 20px;
        outline: 0;
        padding: 15px!important;
        padding: 0 0 0 17px;
        width: 100%;
    }
}
.dateInput .mx-input {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}
.dateInput .mx-datepicker {
    width: 100% !important;
}
.dateInput path {
    fill: #383c4c !important;
}
.floatField_dateInput{
        color: #9598a7;
        font-family: Roboto;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: .1em;
        line-height: 13px;
        margin-top: 0;
        margin-bottom: 0;
        text-transform: uppercase;
        padding: 10px 0 0 17px;
    }
</style>
<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

.form-control{
    border-radius: 0;
}
.form-floating > label {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.05em;
    margin-top: 5px;
    text-transform: uppercase;
    color: #9598a7;
}
.form-group {
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
* {
    font-family: "Roboto", sans-serif;
}
.form-floating {
    width: 100%;
    margin: 0 auto;
    position: relative;
    .counter {
        position: absolute;
        right: 5px;
        bottom: 5px;
        font-size: 10px;
        font-weight: 300;
        color: #9598a7;
    }
}
.modal {
    display: block;
    position: fixed;
    z-index: 10000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: rgba(33, 37, 65, 0.89);
    backdrop-filter: blur(5px);
    cursor: default;
    .modal-content {
        margin: 100px auto 100px auto;
        background: #FFF;
        width: 674px;
        border-radius: 4px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
        padding-bottom: 50px;
        .modal-line {
            width: 673px;
            height: 1px;
            background: #393D56;
        }
        .modal-header {
            margin: 26px auto;
            width: 578px;
            display: flex;
            align-items: center;
            padding: 0;
            border: none;
            .center_section{
                display: flex;
                justify-content: space-between;
                gap: 95px;
                align-items: center;
                h1{
                    color: #212541;
                    font-family: Roboto;
                    font-size: 29px;
                    font-style: normal;
                    font-weight: 300;
                    line-height: normal;
                    margin: 0;
                }
                p{
                    width: 280px;
                    color: #212541;
                    font-family: Roboto;
                    font-size: 15px;
                    font-style: normal;
                    font-weight: 300;
                    line-height: normal;
                    margin: 0;
                    b{
                        font-weight: 700;
                    }
                }
            }
            input {
                width: 427px;
                height: 34px;
                text-align: left;
                font-family: Roboto;
                font-size: 29px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                color: #212541; // Change text color to #212541
                &::placeholder {
                    color: #a3a3a3; // Change placeholder color to #A3A3A3
                }
            }
            svg {
                transition: transform 0.5s;
                &:hover {
                    cursor: pointer;
                    transform: scale(1.3);
                }
            }
        }
        .modal-body {
            padding: 0;
            .history_list{
                padding: 40px 0;
                width: 100%;
                background: #F7F7F7;
                h6{
                    color: #212541;
                    font-family: Roboto;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    margin-bottom: 24px;
                    margin-left: 72px;
                }
                p{
                    color: #212541;
                    font-family: Roboto;
                    font-size: 15px;
                    font-style: normal;
                    font-weight: 300;
                    line-height: normal;
                    margin-left: 74px;
                }
                .list_container{
                    position: relative;
                    width: auto;
                    margin: 0 auto;
                    max-height: 400px;
                    overflow-x: auto;
                    padding-left: 109px;
                    margin-right: 36px;
                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        background: #E8EAEB;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #B1B6BA;
                        border-radius: 6px;
                        opacity: 0.9;
                        &:hover {
                            opacity: 1;
                        }
                    }
                    .list_box{
                        margin-bottom: 20px;
                        border-radius: 6px;
                        background: #FFF;
                        display: flex;
                        width: 500px;
                        padding: 20px;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 4px;
                        position: relative;
                        &.form_accepted{
                            background: #CBF3B8;
                        }
                        &.form_decline{
                            background: #ffc6c4;
                        }
                        &:hover{
                            .actions{
                                opacity: 0.7;
                            }
                        }
                        .actions{
                            display: flex;
                            align-items: center;
                            position: absolute;
                            bottom: 10px;
                            right: 10px;
                            transition: opacity .2s;
                            gap: 5px;
                            opacity: 0;
                            cursor: pointer;
                        }
                        .left_side{
                            position: absolute;
                            left: -39px;
                            top: 5px;
                            display: flex;
                            flex-direction: column;
                            height: 100%;
                            align-items: center;
                            .clock{
                                margin-bottom: 5px;
                            }
                            .line_down{
                                width: 1px;
                                height: 100%;
                                background: #DDE3E8;
                            }
                        }
                        svg.corner{
                            position: absolute;
                            left: -10px;
                            top: 6px;
                        }
                        span{
                            color: #9598A7;
                            font-family: Roboto;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                        p{
                            color: #212541;
                            font-family: Roboto;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                            margin: 0;
                            white-space: pre-line;
                        }
                    }
                }
            }
            .main {
                width: 578px;
                margin: 0 auto;
                padding: 20px 20px 0 20px;
                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
                h3 {
                    width: auto;
                    font-family: "Roboto";
                    font-style: normal;
                    font-weight: 700;
                    font-size: 18px;
                    line-height: 21px;
                    color: #212541;
                }
                p {
                    font-family: "Roboto";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 16px;
                    color: #9598a7;
                }
            }
        }
    }
}
.action_btns_bottom{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 540px;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
        width: 90%;
    }
    .back_btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 103px;
        @media only screen and (max-width: 600px) {
            width: 40%;
        }
        height: 55px;
        flex-shrink: 0;
        border-radius: 4px;
        border: 1px solid #DDE3E8;
        color: #212541;
        text-align: center;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        cursor: pointer;
        transition: 0.5s all;
        &:hover {
            background: #f8f7f7;
        }
    }
    .ulozit {
        width: 227px;
        height: 55px;
        flex-shrink: 0;
        @media only screen and (max-width: 600px) {
            width: 50%;
        }
        border-radius: 4px;
        background: #2ED8B6;

        color: #FFF;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;

        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        cursor: pointer;
        transition: 0.5s all;
        &:hover {
            background: #23caa9;
        }
    }
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}
</style>
